import "../css/TeamInvite.css";

import { useEffect, useState } from "react";

import logo from "../assets/logo.svg";
import profile from "../assets/profile.svg";

import { defaultScheme } from "../App";
import { firestore } from "../firebase";

// 표시되는 이름은 최대 5글자로 제한
const getMaxLengthName = (name) => {
  if (name.length <= 5) {
    return name;
  } else {
    return name.slice(0, 5) + "...";
  }
};

const TeamInviteScreen = ({ inviteCode, teamData }) => {
  const [isFocused, setIsFocused] = useState(true);
  useEffect(() => {
    const checkIsBlur = () => {
      setIsFocused(false);
    };

    window.addEventListener("blur", checkIsBlur);

    return () => window.addEventListener("blur", checkIsBlur);
  }, []);

  // 암호화된 key를 다시 올바른 scheme으로 변환하는 작업 필요
  const getScheme = async (key) => {
    window.location.replace(`${defaultScheme}key=${key}`);

    setTimeout(() => {
      if (isFocused === true) {
        window.location.href = "https://momocalendar.page.link/install";
      }
    }, 500);
  };

  const [teamName, setTeamName] = useState(null);

  const [leaderId, setLeaderId] = useState(null);
  const [leaderData, setLeaderData] = useState(null);

  // 팀의 이름을 불러오고, 팀장의 ID 추출
  useEffect(() => {
    if (teamData) {
      setTeamName(getMaxLengthName(teamData.name));
      setLeaderId(teamData.teamLeader);
    }
  }, [teamData]);

  // 팀장 이름 추출
  useEffect(() => {
    if (leaderId) {
      firestore
        .collection("userData")
        .doc(leaderId)
        .get()
        .then((user) => {
          setLeaderData(user.data().profile);
        });
    }
  }, [leaderId]);

  const onClick = () => {
    getScheme(inviteCode);
  };

  return (
    teamData &&
    leaderData && (
      <div className="container">
        <header className="App-header">
          <img src={logo} className="logo" alt="logo" />
        </header>
        <div className="App-body">
          <div className="information">
            {
              <img
                src={leaderData.image ? leaderData.image : profile}
                alt="profile"
                style={styles.profileImage}
              />
            }
            <span style={styles.emphasizedFont}>{leaderData.name}</span> 님이
          </div>
          <div className="information">
            {
              <img
                src={teamData.image ? teamData.image : profile}
                alt="profile"
                style={styles.profileImage}
              />
            }
            <span style={styles.emphasizedFont}>
              {getMaxLengthName(teamName)}
            </span>
            달력으로 초대했습니다
          </div>
        </div>
        <button className="button" onClick={onClick}>
          달력으로 이동하기
        </button>
      </div>
    )
  );
};

const styles = {
  emphasizedFont: {
    color: "#5f39ca",
    paddingLeft: 15,
    paddingRight: 10,
    justifyContent: "center",
    alignItems: "center",
  },
  profileImage: { width: 50, height: 50, borderRadius: 50 },
};

export default TeamInviteScreen;
